import { useProbationApi, parseFilterParams } from '@pages/tutor-kanban'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const params = parseFilterParams(to.query)

  void useProbationApi({ params })
})
